/*
* blazingcard
* http://www.blazingcard.com
*
* Copyright (c) 2022 Kellton Tech Pvt Ltd
* Author Kellton Tech Pvt Ltd <support@blazingcard.com>
* Licensed under the MIT license.
*/
export class TaxNewForm {
  public taxName: string;
  public taxPercentage: number;
  public taxStatus: number;
  public taxId: number;

  constructor(taxNewForm: any) {
    this.taxName = taxNewForm.title || '';
    this.taxPercentage = taxNewForm.value || 0;
    this.taxStatus = taxNewForm.status || 0;
    if (taxNewForm.taxId) {
      this.taxId = taxNewForm.taxId || '';
    }
  }
}
